<script>
export default {
    props: {
        options: {
            type: Array
        },
        selected: {
            type: Number
        }
    },
    data() {
        return {
            selectedValue: 'todos',
        }
    },
    created() {
        this.selectedValue = this.selected;
    },
    methods: {
        handleChange(event) {
            return this.$emit('handleChange', this.selectedValue);
        }
    }
}
</script>

<template>
    <section class="bg-input">
        <label for="">Selecione uma categoria</label>
        <select name="" id="" v-model="selectedValue" @change="handleChange($event)">
            <option v-for="(option, index) in options" :value="option.value" >{{ option.name }}</option>
        </select>
    </section>
</template>

<style scoped>
.bg-input {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.bg-input label {
    margin-bottom: 10px;
    font-weight: 450;
    font-size: 16px;
    color: rgb(28, 28, 28);
}

.bg-input select {
    padding: 8px 10px;
    width: 100%;
    font-size: 16px;
    border-radius: 6px;
}
</style>